module.exports = __webpack_public_path__ + "static/media/icn-sun.4c1506fe.svg";